import { render, staticRenderFns } from "./EmdBreadcrumb.vue?vue&type=template&id=c2474fdc&"
import script from "./EmdBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./EmdBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmdBreadcrumb.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2474fdc')) {
      api.createRecord('c2474fdc', component.options)
    } else {
      api.reload('c2474fdc', component.options)
    }
    module.hot.accept("./EmdBreadcrumb.vue?vue&type=template&id=c2474fdc&", function () {
      api.rerender('c2474fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/molecules/EmdBreadcrumb.vue"
export default component.exports